// extracted by mini-css-extract-plugin
export default {"container":"feature-card_container__dW6hD","image":"feature-card_image__1B6Vn","text":"feature-card_text__74ry1","text1":"feature-card_text1__VL45x"};